function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    style: {
      fill: "rgb(255, 212, 212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 25H25C23.3425 25 22.015 26.3425 22.015 28L22 46C22 47.6575 23.3425 49 25 49H49C50.6575 49 52 47.6575 52 46V28C52 26.3425 50.6575 25 49 25ZM49 31L37 38.5L25 31V28L37 35.5L49 28V31Z",
    style: {
      fill: "rgb(242, 2, 2)"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d4ebf405cafc2ac9e0df56426ace3653.svg";
export { ForwardRef as ReactComponent };